import { Pipe, PipeTransform } from '@angular/core';
import { getAppVersion } from '../constants/app-version';

@Pipe({ name: 'appVersion' })
export class AppVersionPipe implements PipeTransform {
    transform(_value?: any): string {
        return getAppVersion();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/app-version.pipe.ts